
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';



export default function AuthGuard({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const isAuthenticated = localStorage.getItem('isAuthenticated');
    const publicRoutes = ['/auth/login', '/auth/register', '/auth/forgot-password', '/auth/onboarding'];
    
    // If not authenticated and trying to access protected route
    if (!isAuthenticated && !publicRoutes.includes(location.pathname)) {
      navigate('/auth/login');
      return;
    }

    // If authenticated and trying to access auth routes, redirect to home
    if (isAuthenticated && publicRoutes.includes(location.pathname) && location.pathname !== '/auth/onboarding') {
      navigate('/');
      return;
    }
  }, [navigate, location.pathname]);

  return <>{children}</>;
}
